import React, { useRef, useState, useCallback, useEffect } from 'react';

export function VirtualTable({ rows, renderRow, headers, colTemplate, containerHeight = 520, overscan = 10, rowHeight = 40, threshold = 100 }: any) {
  const scrollRef = useRef(null);
  const [scrollTop, setScrollTop] = useState(0);

  const onScroll = useCallback(() => {
    if (scrollRef.current) setScrollTop((scrollRef.current as any).scrollTop);
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    (el as any).addEventListener('scroll', onScroll, { passive: true });
    return () => (el as any).removeEventListener('scroll', onScroll);
  }, [onScroll]);

  const totalHeight = rows.length * rowHeight;
  const startIdx = Math.max(0, Math.floor(scrollTop / rowHeight) - overscan);
  const visibleCount = Math.ceil(containerHeight / rowHeight) + overscan * 2;
  const endIdx = Math.min(rows.length, startIdx + visibleCount);
  const visibleRows = rows.slice(startIdx, endIdx);

  return (
    <div
      className="vtable-container"
      ref={scrollRef}
      style={{ height: containerHeight, overflowY: 'auto' }}
    >
      <div className="vtable-header" style={{ gridTemplateColumns: colTemplate }}>
        {headers.map((h: string, i: number) => <div key={i} className="vtable-header-cell">{h}</div>)}
      </div>

      <div className="vtable-scroll" style={{ height: totalHeight, position: 'relative' }}>
        {visibleRows.map((row: any, i: number) => {
          const absoluteIdx = startIdx + i;
          return (
            <div
              key={row.id || `${row.idx}-${row.rawDate}`}
              className={`vtable-row ${row.status === 'posted' ? 'row-imported' : !row.isValid ? 'row-error' : row.isDuplicate ? 'row-duplicate' : ''}`}
              style={{
                top: absoluteIdx * rowHeight,
                gridTemplateColumns: colTemplate,
                height: rowHeight,
              }}
            >
              {renderRow(row)}
            </div>
          );
        })}
      </div>

      {rows.length >= threshold && (
        <div className="vtable-perf-note">
          <span className="spinner" style={{ width: 8, height: 8, borderWidth: 1.5 }} />
          Virtualised rendering active — showing {Math.min(visibleCount, rows.length)} of {rows.length} rows
        </div>
      )}
    </div>
  );
}
